import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, NonIdealState } from '@blueprintjs/core';
import { Browser, List, Page } from "../../utils/Layout/Layout";
import Line from "../../utils/Line/Line";
import { TorgaContext, useTorgaContext } from "../TorgaContext";
import { ObjectTypes, urlToActivityID } from "../TorgaRouter";
import Activity from "./Activity";
import { actionActivityCreate, actionActivityUpdate } from './actions';

export default function Activities() {
  const { state, dispatchAction } = useTorgaContext();
  const navigate = useNavigate();
  const params = useParams();

  const hasRootActivity =
    state.activities.rootID !== undefined && state.activities.rootID !== null;

  if (!hasRootActivity) {
    if (state.activities.allIDs.length === 0) {
      return (
        <div style={{ paddingTop: 40 }}>
          <NonIdealState
            icon="flow-branch"
            title="No activities yet"
            description="Create your ROOT activity to initialize the activity tree."
            action={
              <Button
                intent="primary"
                onClick={() => {
                  dispatchAction(actionActivityCreate(null, 'ROOT'));
                }}
              >
                Create ROOT activity
              </Button>
            }
          />
        </div>
      );
    }

    return <div>Loading activities...</div>;
  }

  return (
    <Browser>
      <List>
        <Line
          id={state.activities.rootID}
          selectedID={params.id?.slice(1)}
          context={TorgaContext}
          type={ObjectTypes.ACTIVITIES}
          prefix={"A"}
          link={(id) => urlToActivityID(id)}
          onSelect={(id) => {
            navigate(urlToActivityID(id));
          }}
          moveObject={(id, newParent) => {
            dispatchAction(actionActivityUpdate(id, 'parent_id', newParent));
          }}
        />
      </List>
      <Page>
        <Activity />
      </Page>
    </Browser>
  );
}
